import { Form, Card, Button } from 'tabler-react'

const FormCard = ({
  children,
  action,
  method,
  onSubmit,
  title,
  buttonText,
  loading
}) => (
    <Form className="card mx-auto margin-none" onSubmit={onSubmit} action={action} method={method}>
      <Card.Body className="p-6">
        <Card.Title RootComponent="div">{title}</Card.Title>
        {children}
        <Form.Footer>
          <Button type="submit" color="primary" block={true} loading={loading}>
            {buttonText}
          </Button>
        </Form.Footer>
      </Card.Body>
    </Form>
  )

export default FormCard